import React, { Component } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { jarallaxElement } from 'jarallax';
import styled from 'styled-components';
import CarPageAvatar from '../CarPageAvatar';
import NumberInput from './NumberInput';

import '../../styles/components/SectionContact.css';

export const SummaryWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    margin-top: 40px;

    label {
        margin: 0;
        font-family: 'Roboto Mono';
        text-transform: uppercase;
        font-size: 12px;
        font-weight: 300;
        color: white;
    }

    p {
        font-family: 'Roboto Mono';
        font-size: 26px;
        line-height: 1.5;
        text-transform: none;
        color: #fff;
        font-weight: 300;
        max-width: 430px;
        margin: 55px 0;

        @media (max-width: 767.98px) {
            max-width: 100%;
        }
    }

    button {
        max-width: 350px;
        margin-bottom: 100px;

        @media (max-width: 767.98px) {
            margin-bottom: 0;
        }
    }
`;

export const SummaryWrapperNumber = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #2d2e30;
    padding-bottom: 25px;

    span {
        font-family: 'Roboto Mono';
        margin-right: auto;
        color: #ff5000;
        align-self: flex-end;
        margin-bottom: 10px;
        white-space: nowrap;
    }

    > span {
        color: #7f7f7f;
    }

    button {
        height: 50px;
        align-self: flex-end;
        margin-bottom: 10px;

        @media (max-width: 767.98px) {
            height: auto;
            width: 100%;
            margin-top: 30px;
        }
    }
`;

const LeftWrapper = styled.div`
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 350px;
    z-index: 1;
    border-right: 30px solid white;

    @media (max-width: 767.98px) {
        position: relative;
        margin: 0 auto;
        border: none;
    }
`;

export default class EmptyCalculator extends Component {
    state = {};

    // onChange = (fieldName, fieldValue) => {
    //   this.setState(
    //     {
    //       [fieldName]: fieldValue
    //     },
    //     () => {
    //       if (this.props.saveCalcData) {
    //         this.props.saveCalcData(this.state);
    //       }
    //     }
    //   );
    // };

    setScrollMouseMargin() {
        if ($('.section-contact .right-side').length === 1) {
            const fromLeft = $('.section-contact .right-side').offset().left;
            var styleElem = document.head.appendChild(
                document.createElement('style')
            );
            styleElem.innerHTML = `
      .line::before,
      .scroll::before,
      .scroll::after {
        left:${fromLeft}px
      }
      `;
        }
    }

    componentDidMount() {
        (async () => {
            try {
                $(document).ready(() => {
                    jarallaxElement();
                    this.setScrollMouseMargin();
                });
            } catch (err) {
                console.error(err);
            }
        })().catch(err => {
            console.error(err);
        });
    }

    render() {
        jarallaxElement();
        const { carData } = this.props;
        // console.log(`carData`, carData);

        const priceType = _.get(
            carData,
            'acf.prices.rentFromPrice.rentFromPriceType',
            ''
        );
        const priceValue = _.get(
            carData,
            'acf.prices.rentFromPrice.rentFromPriceValue',
            0
        );

        return (
            <div className="split split__rent split__rent--black">
                <div className="section-contact container container-small">
                    <div className="row">
                        <LeftWrapper>
                            <CarPageAvatar carData={carData} />
                        </LeftWrapper>
                        <div className="col-12 col-md-10 offset-md-2 right-side right-side-calc">
                            <div className="row">
                                <div className="col-12 col-md-8 offset-md-4 car-price-list--wrapper">
                                    <SummaryWrapper>
                                        {priceValue && (
                                            <>
                                                <label>
                                                    {priceType === 'rent'
                                                        ? 'Wynajem '
                                                        : 'Leasing '}
                                                    już od
                                                </label>
                                                <SummaryWrapperNumber>
                                                    <NumberInput
                                                        summary
                                                        displayType="text"
                                                        value={priceValue}
                                                    />
                                                    <span>/mies.</span>
                                                </SummaryWrapperNumber>
                                            </>
                                        )}
                                        <p>
                                            Oferta opracowywana indywidualnie
                                            przez naszego Motoconcierge.
                                        </p>
                                        <button
                                            className="btn-general btn-general--primary"
                                            onClick={this.props.showModal}
                                        >
                                            Sprawdź szczegóły
                                        </button>
                                    </SummaryWrapper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

EmptyCalculator.defaultProps = {};

EmptyCalculator.propTypes = {};
